package nl.astraeus.wiki.messages

class RemoveWikiMessage() : Message(
  MessageType.REMOVE_WIKI,
  MessageHeader.WIKI_ID,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(wikiId: Long) : this() {
    setHeader(MessageHeader.WIKI_ID, wikiId.toString())
  }
}
